import i18n from "i18next"
import { initReactI18next } from "react-i18next"

import { ar } from "./ar"
import { en } from "./en"

export const defaultNS = "translation" as const
export const resources = {
  en: {
    translation: en,
  },
  ar: {
    translation: ar,
  },
} as const

i18n.use(initReactI18next).init({
  defaultNS,
  resources,
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
})

export default i18n
